import colors from '../../../helpers/colors';
import { PanelColors } from '../types';

export enum PanelOptions {
  SUCCESS = 1,
  NEUTRAL,
  ERROR,
  WARNING,
  INFO,
  NONE,
}

export const getPanelColors = (option: PanelOptions): PanelColors | undefined => {
  switch (option) {
    case PanelOptions.SUCCESS:
      return {
        primaryColor: colors.notificationSuccess,
        lightColor: colors.notificationSuccessLight,
      };
    case PanelOptions.NEUTRAL:
      return {
        primaryColor: colors.neutral01,
        lightColor: colors.neutral04,
      };
    case PanelOptions.ERROR:
      return {
        primaryColor: colors.notificationError,
        lightColor: colors.notificationErrorLight,
      };
    case PanelOptions.WARNING:
      return {
        primaryColor: colors.notificationWarning,
        lightColor: colors.notificationWarningLight,
      };
    case PanelOptions.INFO:
      return {
        primaryColor: colors.notificationInfo,
        lightColor: colors.notificationInfoLight,
      };
    default:
      return undefined;
  }
};
